<div class="[ cover-principal ] [ flex flex-column p-2xs ] [ overflow-y-auto ]">
  <div class="[ flex ] [ m-i-auto ]">
    <div> <ng-content select="campus-feedback-host"></ng-content></div>

    <div>
      <div class="[ flex flex-1 ] [ m-i-auto ]">
        <ng-content select="campus-speech-bubble"></ng-content>
      </div>
      <div class="[ flex flex-1 ] [ m-i-auto ]">
        <ng-content select="campus-reward"></ng-content>
      </div>
    </div>
  </div>
</div>

<div class="[ stack justify-end overflow-visible ]">
  <div class="[ border ] [ -m-i-m ]"></div>
  <campus-timer-button [time]="time" (stopped)="stopped.emit()" class="[ m-is-auto ]">
    {{ nextLabel }}
  </campus-timer-button>
</div>
